import { Capacitor } from '@capacitor/core';
import { App } from '@capacitor/app';

/**
 * Check if the app is running as a native mobile app
 */
export const isNativePlatform = (): boolean => {
  return Capacitor.isNativePlatform();
};

/**
 * Get the current platform (ios, android, or web)
 */
export const getPlatform = (): 'ios' | 'android' | 'web' => {
  return Capacitor.getPlatform() as 'ios' | 'android' | 'web';
};

/**
 * Get the installed native app version (e.g. "1.2.3"). Returns null on web.
 * Used by the feature-flag version gate so old mobile builds without
 * new lock UI are not enforced.
 */
export const getAppVersion = async (): Promise<string | null> => {
  if (!Capacitor.isNativePlatform()) return null;
  try {
    const info = await App.getInfo();
    return info?.version ?? null;
  } catch (e) {
    console.warn('Failed to read app version:', e);
    return null;
  }
};
